import React from "react";

export const contextapi = React.createContext();
